import { selectCashFromSale } from './equity'

export const selectSellPocketAmount = selectCashFromSale
